import * as React from "react"
import { Button, ListItem, Stack, Text, UnorderedList, useDisclosure, VStack } from "@chakra-ui/react"

import { hasExpired, hasPassedFirstRound } from "lib/helpers/competition"
import { useMe } from "lib/hooks/useMe"

import { CompetitionDetailFragment } from "../lib/graphql"
import { LinkButton } from "./LinkButton"
import { LoginForm } from "./LoginForm"
import { Modal } from "./Modal"
import { hasCompletedProfile } from "lib/helpers/user"

export const CompetitionActions: React.FC<{ competition: CompetitionDetailFragment }> = ({ competition }) => {
  const { me } = useMe()
  const modalProps = useDisclosure()
  const completeProfileProps = useDisclosure()

  const handleGoToLogin = () => {
    modalProps.onOpen()
  }

  return (
    <VStack w="100%" justify="space-between">
      {!competition.isFinal && (
        <VStack w="100%">
          {me ? (
            <>
              {hasPassedFirstRound(competition) ? (
                <Button w="100%" colorScheme="pink" isDisabled>
                  Voorronde verstreken
                </Button>
              ) : !hasCompletedProfile(me) ? (
                <Button colorScheme="yellow" w="100%" onClick={completeProfileProps.onOpen}>
                  Doe mee
                </Button>
              ) : (
                <LinkButton
                  isDisabled={competition.isFinal}
                  w="100%"
                  href={`/wedstrijd/${competition.slug}/apply`}
                  colorScheme="yellow"
                >
                  Doe mee
                </LinkButton>
              )}
            </>
          ) : (
            <Button w="100%" colorScheme="yellow" variant="outline" onClick={handleGoToLogin}>
              Login om je aan te melden
            </Button>
          )}
        </VStack>
      )}
      {competition.ticketLink && (
        <LinkButton isExternal w="100%" variant="outline" href={competition.ticketLink} colorScheme="yellow">
          Tickets
        </LinkButton>
      )}
      {competition.shopLink && (
        <LinkButton isExternal w="100%" variant="outline" href={competition.shopLink} colorScheme="yellow">
          Merchandise
        </LinkButton>
      )}

      <Modal {...modalProps}>
        <LoginForm handleSubmit={modalProps.onClose} />
      </Modal>

      <Modal {...completeProfileProps}>
        <Stack py={4}>
          <Text fontSize="lg" fontWeight="bold">
            Voltooi je profiel om door te gaan
          </Text>
          <Text>
            Je moet de onderstaande informatie aan je profiel toevoegen voordat je zich kunt aanmelden voor
            een wedstrijd
          </Text>
          <UnorderedList>
            {!me?.lastName && <ListItem>Achternaam</ListItem>}
            {!me?.address && <ListItem>Adres</ListItem>}
            {!me?.postcode && <ListItem>Postcode</ListItem>}
            {!me?.residence && <ListItem>Woonplaats</ListItem>}
            {me?.pronounsMulti?.length === 0 && <ListItem>Voornaamwoorden</ListItem>}
          </UnorderedList>
          <LinkButton href={`/users/${me?.id}/edit`} colorScheme="yellow">
            Profiel bewerken
          </LinkButton>
        </Stack>
      </Modal>
    </VStack>
  )
}
